import React from 'react';
import styled, { css } from 'styled-components';

import { useMedia } from '@tager/web-core';

import DetailedCarGallery from '@/components/DetailedCarGallery';
import Share, { DropDownMenu, DropdownToggle } from '@/components/Share';
import { useTypedSelector } from '@/store/store';
import { selectDetailedCarData } from '@/store/reducers/detailed-car';
import CarCurrentState from '@/components/CarCurrentState';
import { media } from '@/utils/mixin';
import defaultStockCar from '@/assets/images/cars-stock/defaultStockCar.png';
import { colors } from '@/constants/theme';
import { CarsStockAvailableStatus } from '@/services/stock/enums';
import Compare from '@/modules/DetailedCar/DetailedCarNew/components/DetailedCarNewMain/components/Compare';

function CarGallery() {
  const isMobile = useMedia('(max-width: 767px)');
  const data = useTypedSelector(selectDetailedCarData);

  if (!data) {
    return null;
  }

  const {
    id,
    status,
    media,
    catalog: { brand, model },
    params: { color },
  } = data;

  const images =
    media.images.length !== 0
      ? media.images.map((image) => ({
          desktop: image,
          mobile: image,
        }))
      : [{ desktop: defaultStockCar, mobile: defaultStockCar }];

  return (
    <Component>
      <Compare />

      <ShareWrapper images={images} className="disabled-modal">
        <Share
          path={`/cars/new/${id}`}
          image={images && images.length !== 0 ? images[0].desktop : ''}
        />
      </ShareWrapper>

      {status?.id === CarsStockAvailableStatus.Booked && (
        <CarCurrentStateWrapper images={images}>
          <CarCurrentState text="Забронирован" />
        </CarCurrentStateWrapper>
      )}

      <DetailedCarGallery
        layout={isMobile ? 'mobile' : 'desktop'}
        images={images}
        alt={`${brand.name} ${model?.name ?? ''} ${color?.label ?? ''}`}
      />
    </Component>
  );
}

export default CarGallery;

const Component = styled.div`
  position: relative;
  margin-top: 25px;

  ${media.tablet(css`
    margin-top: 12px;
  `)}
`;

const ShareWrapper = styled.div<{ images: any[] }>`
  position: absolute;
  display: flex;
  left: 20px;

  z-index: 2;
  width: 48px;
  height: 48px;
  background: ${colors.white};
  border-radius: 50%;
  justify-content: center;
  align-items: center;

  ${DropDownMenu} {
    padding-left: 15px;
  }

  ${DropdownToggle} {
    color: ${colors.black200};
  }

  ${({ images }) =>
    images.length > 1
      ? css`
          bottom: 22%;
        `
      : css`
          bottom: 20px;
        `};

  ${media.mobile(
    css`
      display: none;
    `
  )}
`;

const CarCurrentStateWrapper = styled.div<{ images: any[] }>`
  position: absolute;
  z-index: 2;
  right: 20px;

  ${media.mobile(css`
    bottom: 12px;
  `)}

  ${({ images }) =>
    images.length > 1
      ? css`
          bottom: 22%;
        `
      : css`
          bottom: 20px;
        `}
`;
